import styled from "styled-components";
export const HeaderStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;
export const HeaderText = styled.div`
  font-size: 20px;
  font-weight: 900;
  white-space: nowrap;
`;
export const BackBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 30px;
  box-shadow: 0 1px 3px 0 rgba(53, 58, 80, 0.1);
  background-color: #fff;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const InputStyled = styled.input`
  margin: 5px 0;
  padding: 10px;
  border-radius: 8px;
  background-color: #fff;
`;
export const TextAreaStyled = styled.textarea`
  margin: 5px 0;
  padding: 10px;
  border-radius: 8px;
  background-color: #fff;
  border: none;
  height: 15vh;
`;

export const VoiceInputStyled = styled.div`
  display: flex;
  justify-content: ${({ done }) => (done ? "center" : "")};
  align-items: center;
  margin: 5px 0;
  padding: 10px;
  border-radius: 8px;
  background-color: #fff;
`;

export const VoiceIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px 0 rgba(255, 191, 29, 0.25);
  background-color: #ffbf1d;
  border-radius: 25px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const AudioPlayer = styled.audio`
  border-radius: 8px;
  background-color: #fff;
  width: 75%;
`;
export const AudioPlayerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const DeleteBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0 3px 10px 0 rgba(237, 85, 101, 0.4);
  background-color: #ed5565;
  padding: 8px 10px;
  margin-right: 5px;
`;
export const SendBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0 3px 10px 0 rgba(42, 46, 67, 0.4);
  background-color: #2a2e43;
  padding: 10px 10px;
  margin-right: 5px;
  color: #fff;
`;
export const SelectContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
